<template>
  <div class="rightTableDiv">
    <search-form @setSearchCondition="setSearchCondition" @clearSearch="clearSearch" @changeScrollY="changeScrollY" @saveAdvanced="saveAdvanced" class="searchFormDiv"></search-form>
    <div class="rightBox">
      <div class="rightTreeDiv">
        <equipment-tree-list
          class="equipmentTreeList"
          ref="equipmentTreeList"
          :showSearch="false"
        ></equipment-tree-list>
        <a-pagination v-model="pagination.pageNum" :total="50" show-less-items size="small" />
      </div>
      <div class="tableBox">
        <data-tabs></data-tabs>
      </div>
    </div>
  </div>
</template>
<script>
import SearchForm from '@/views/gasManagement/modules/searchForm'
import equipmentTreeList from '@/views/gasManagement/modules/equipmentTreeList'
import DataTabs from './dataTabs.vue'
import { getTableScroll } from '@/views/gasManagement/modules/height'
import { mapGetters } from 'vuex'
export default {
  name: 'TableData',
  components: {
    DataTabs,
    equipmentTreeList,
    SearchForm
  },
  computed: {
    ...mapGetters(['gasManagementCompanyId'])
  },
  data () {
    return {
      searchValue: '',
      // 表格数据
      tableData: {
        data: [],
        loading: false
      },
      sortedInfo: null,
      scrollY: 0,
      toLeftWidth: 0,
      advanced: false,
      // 搜索条件
      searchModel: {},
      pagination: {
        pageNum: 1,
        pageSize: 20,
        total: 0,
        pageSizeOptions: ['10', '20', '30', '40'],
        showSizeChanger: true,
        showQuickJumper: true
      },
      sort: {},
      // 左侧树的搜索条件
      treeSearchModel: {}
    }
  },
  created () {
  },
  mounted () {

  },
  watch: {
    gasManagementCompanyId (newValue) {
      if (newValue.id !== '') {
        if (newValue.id === '空') {
          delete this.treeSearchModel.comid
          this.tableData.data = []
          this.pagination.total = 0
          this.tableData.loading = false
          const dom = document.getElementsByClassName('ant-table-body')[0]
          dom.classList.add('ant-table-body-max-height-0')
          if (this.advanced) {
            this.changeScrollY(90, 'addAssetTableHeigth')
          } else {
            this.changeScrollY(94)
          }
        } else {
          this.treeSearchModel.comid = newValue.id
        }
      } else {
        delete this.treeSearchModel.comid
      }
      delete this.searchModel.comid
      if (newValue.id === '空') {
        this.setSearchCondition(this.searchModel)
      }
    }
  },
  methods: {
    // 隐藏展开图标
    expandIcon (props) {
      return null
    },
    // 判断是否展开行
    showLine (expanded, record) {
      // 只展开一行
      if (this.expandedRowKeys.length > 0) { // 进这个判断说明当前已经有展开的了
        // 返回某个指定的字符串值在字符串中首次出现的位置，下标为0
        const index = this.expandedRowKeys.indexOf(expanded.id)
        if (index > -1) { // 如果出现则截取这个id,1d到1相当于0，针对重复点击一个
          this.expandedRowKeys.splice(index, 1)
        } else {
          // 如果没出现则截取所有id,添加点击id，0到1，针对已经有一个展开，点另一个会进入判断
          this.expandedRowKeys.splice(0, this.expandedRowKeys.length)
          this.expandedRowKeys.push(expanded.id)
        }
      } else {
        // 数组长度小于0，说明都没展开，第一次点击，id添加到数组，数组有谁的id谁就展开
        this.expandedRowKeys.push(expanded.id)
      }
    },
    rowClassName (record, index) {
      return (record.id === this.expandedRowKeys[0]) ? 'activeHighLight' : ''
    },
    // 改变scrollY
    changeScrollY (extraHeight, type) {
      this.$nextTick(() => {
        this.scrollY = getTableScroll(extraHeight, 'assetTable', type)
        const dom = document.getElementsByClassName('rightBox')[0]
        console.log(dom)
        if (type === 'addAssetTableHeigth') {
          dom.classList.add('assetTableHeight_126')
        } else {
          dom.classList.remove('assetTableHeight_126')
        }
      })
    },
    // 保存展开状态字段
    saveAdvanced (advanced) {
      this.advanced = advanced
    },
    //  获取部门树用于第一次请求表格
    getDeptData () {
    },
    // 获取表格数据
    getTableData (type) {
      this.tableData.loading = true
      this.searchModel = { ...this.searchModel, ...this.pagination, ...this.sort }
      this.expandedRowKeys = []
      getAssetTableData(this.searchModel).then(res => {
        if (res.status === 0) {
          const dom = document.getElementsByClassName('ant-table-body')[0]
          if (res.data.list.length > 0) {
            dom.classList.remove('ant-table-body-max-height-0')
            for (let i = 0; i < res.data.list.length; i++) {
              const item = res.data.list[i]
              item.id = i
            }
          } else {
            dom.classList.add('ant-table-body-max-height-0')
          }
          this.tableData.data = res.data.list
          this.pagination.total = res.data.total
          this.tableData.loading = false
          if (type === 'changePageNum' && this.advanced) {
            if (this.advanced) {
              this.changeScrollY(90, 'addAssetTableHeigth')
            } else {
              this.changeScrollY(94)
            }
          } else {
            this.changeScrollY(94)
          }
        } else {
          this.tableData.data = []
          this.tableData.total = 0
          this.tableData.loading = false
          this.$message.error(res.info.message)
        }
      })
    },
    // 搜索
    setSearchCondition (searchModel) {
      this.pagination.pageNum = 1
      this.pagination.current = 1
      this.searchModel = searchModel
      this.searchModel = { ...this.searchModel, ...this.treeSearchModel, ...searchModel }
      this.getTableData()
    },
    // 重置
    clearSearch (searchModel) {
      this.sort = {}
      this.sortedInfo = null
      this.pagination.pageNum = 1
      this.pagination.current = 1
      this.searchModel = searchModel
      this.searchModel = { ...this.searchModel, ...this.treeSearchModel }
      this.getTableData()
    },
    // 切换页码等操作
    handleTableChange (pagination, filters, sorter) {
      this.sortedInfo = sorter
      this.pagination.pageSize = pagination.pageSize
      this.pagination.pageNum = pagination.current
      this.pagination.current = pagination.current
      if (sorter.field === 'ordtx') {
        this.sort.sortName = 'ord43'
      } else if (sorter.field === 'txk20') {
        this.sort.sortName = 'anlkl'
      } else if (sorter.field === 'x1') {
        this.sort.sortName = 'txt50'
      } else {
        this.sort.sortName = sorter.field
      }
      if (sorter.order) {
        if (sorter.order === 'ascend') {
          this.sort.sortType = 'asc'
        } else if (sorter.order === 'descend') {
          this.sort.sortType = 'desc'
        }
      } else {
        delete this.sort.sortName
        delete this.sort.sortType
        delete this.searchModel.sortName
        delete this.searchModel.sortType
      }
      this.searchModel = { ...this.searchModel, ...this.treeSearchModel }
      this.getTableData('changePageNum')
    }
  }
}
</script>

<style scoped lang="less">
.rightTableDiv {
  height: 100%;
}
.listContent {
  .table {
    margin-top: 10px;
  }
}
.ant-table-row-collapsed::after {
  content: '+';
  color: #DDDDDD;
}
.ant-table-row-expanded::after {
  content: '-';
  color: #DDDDDD;
}
.assetTableHeight_126 {
  height: calc(100% - 132px) !important;
}
.assetNameTable {
  .txt50Span {
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    display: inline-block;
  }
  //width: 100%;
  //display: flex;
  //flex-direction: row;
  //align-items: center;
  .expandBtn {
    //margin-right: 5px;
  }
}
/deep/.ant-table-align-center {
  padding: 0 !important;
}
/deep/.ant-table-body-max-height-0 {
  max-height: 0 !important;
}
/deep/.ant-table-tbody .activeHighLight{
  background-color: #e6f7ff !important;
}
.rightBox {
  display: flex;
  height: calc(100% - 48px);
  transition: height 300ms ease;
}
.rightTreeDiv {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 300px;
  height: 100%;
  overflow-y: hidden;
  border-right: 2px solid #f0f2f5;
  margin-right: 10px;
  .equipmentTreeList {
    height: calc(100% - 25px);
    width: 100%;
  }
}
.tableBox {
  width: calc(100% - 312px);
  height: 100%;
}
</style>
